// extracted by mini-css-extract-plugin
export default {"bodyCell":"SettingsNotifications_bodyCell__EkjDF","actionsContainer":"SettingsNotifications_actionsContainer__I1pV9","editIcon":"SettingsNotifications_editIcon__YMxtV"};